import { Status as TrackingStatus } from '~api/wimo';

import { LocalizationKey } from '~src/i18n/use-translation';

export const getTrackingEventStatusLabel = (status?: TrackingStatus): LocalizationKey =>
  `shipments.trackingEvents.status.${status ?? 'UNKNOWN'}`;
